import api from './api';

export const purchaseService = {
  /** Auth via cookie HttpOnly (withCredentials) — não usa Bearer. */
  getPurchaseRequests: async () => {
    const response = await api.get('/purchase-request/');
    return response.data;
  },

  createPurchaseRequest: async (payload) => {
    try {
      const response = await api.post('/purchase-request/', payload);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao criar solicitação de compra:', error);
      throw error;
    }
  },
};
